import { useState } from "react";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import PersonalizedSection from "@/components/site/PersonalizedSection";
import RakhiGiftingSection from "@/components/site/RakhiGiftingSection";
import BulkGiftingSection from "@/components/site/BulkGiftingSection";
import ShopByOccasionSection from "@/components/site/ShopByOccasionSection";
import FAQSection from "@/components/site/FAQSection";
import Footer from "@/components/site/Footer";
import WhatsAppBubble from "@/components/site/WhatsAppBubble";
import ConfiguratorDialog from "@/components/site/ConfiguratorDialog";
import Seo from "@/components/Seo";

export default function HomePage() {
  const [config, setConfig] = useState({ product: null, initialPhotoFile: null, initialText: "" });

  const openFor = (product) =>
    setConfig({ product, initialPhotoFile: null, initialText: "" });

  const close = (open) => {
    if (!open) setConfig({ product: null, initialPhotoFile: null, initialText: "" });
  };

  return (
    <div className="relative min-h-screen">
      <Seo
        title="Shine on Coin — Personalized Gold & Silver Engravings"
        description="Shine on Coin hand-engraves 99.9 silver coins, gold lockets & bracelets with your photograph. Custom gifts for weddings, anniversaries & corporate gifting, made in Hyderabad."
        path="/"
      />
      <Navbar />
      <main className="relative">
        <Hero />
        <PersonalizedSection onCustomize={openFor} />
        <RakhiGiftingSection />
        <BulkGiftingSection />
        <ShopByOccasionSection />
        <FAQSection />
      </main>
      <Footer />
      <WhatsAppBubble />
      <ConfiguratorDialog
        product={config.product}
        open={!!config.product}
        onOpenChange={close}
        initialPhotoFile={config.initialPhotoFile}
        initialText={config.initialText}
      />
    </div>
  );
}
